<template>
  <div class="actioncontent cadfm-flexitem-stretched " >

      <slot></slot>

  </div>
</template>
<script>
//bg-dark text-light as class

//import DataTableComponentSimple from "@/components/shared/DataTableComponentSimple"
//import EmptyComponent from "@/components/shared/EmptyComponent"
export default {
  name: "ActionContent"
}
</script>

<style scooped>
  .actioncontent{
    margin-top: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ActionContent.vue